// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DealsContainer_wrapper__2GJXe","container":"DealsContainer_container__18Nj-","dealList":"DealsContainer_dealList__1Kzsb"};